import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import FollowersListWrapper from "@/components/utils/followers/FollowersListWrapper";
import useFollowersList from "@/hooks/useFollowersList";
export default function UserPageFollowersModal(t0) {
  const $ = _c(11);
  const {
    profileId,
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== isOpen || $[1] !== profileId) {
    t1 = {
      profileId,
      enabled: isOpen
    };
    $[0] = isOpen;
    $[1] = profileId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    followers,
    isFetching,
    onBottomIntersection
  } = useFollowersList(t1);
  let t2;
  if ($[3] !== followers || $[4] !== isFetching || $[5] !== onBottomIntersection) {
    t2 = <div><FollowersListWrapper followers={followers} loading={isFetching} onBottomIntersection={onBottomIntersection} showFollowButtons={true} /></div>;
    $[3] = followers;
    $[4] = isFetching;
    $[5] = onBottomIntersection;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== t2) {
    t3 = <MobileWrapperDialog title="Followers" isOpen={isOpen} onClose={onClose} tall={true} fixedHeight={true} tabletModal={true} maxWidthClass="md:tw-max-w-md" showScrollbar={true}>{t2}</MobileWrapperDialog>;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}